export default __webpack_public_path__ + "images/23_2_image.jpg";